import { ThunkDispatch } from "redux-thunk";

import CreateApiModule from "@/redux/create-api-module";
import { IState, TApiAction, TExtraThunkArgs } from "@/redux/store.types";
import { Config } from "@/utils/config.utils";

import {
    $PaymentMethodsModuleName,
    TPaymentMethodsState
} from "./paymentMethods.types";

const { actions, constants } = CreateApiModule(
    $PaymentMethodsModuleName,
    ({ url }) => url
);

export const load =
    () =>
    async (
        dispatch: ThunkDispatch<
            IState,
            TExtraThunkArgs,
            TApiAction<TPaymentMethodsState>
        >
    ) =>
        await dispatch(
            actions.load(
                {
                    path: {
                        url: `/cartservice/${Config.general.basestore}/checkout/paymentmethods`
                    }
                },
                "GET",
                true
            )
        );

export const clear = actions.clear;
export const refetch = actions.refetch;
export const ApiStatus = constants;
